// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"03c6942c","545":"dd1e8118","985":"d0932d32"}[chunkId] + ".chunk.js";
};